<template>
    <div>
        <!-- <template v-if="file !== null">
            <div>
                <span style="color:red;">文件名: {{ file.name }}</span>
            </div>
        </template> -->
        <img v-if="value !== '' && value !== null && showImage && !isMp4()"
            :src="imgPath"
            :width="imgWidth"
            :height="imgHeight">
        <video v-if="value !== '' && value !== null && showImage && isMp4()"
            :src="imgPath"
            :width="imgWidth"
            :height="imgHeight" preload />
        <div style="display:flex;flex-direction:row;">
            <Upload :show-upload-list="false"
                :data="uploadParams"
                :action="action"
                :format="format"
                :on-success="handleUploadFileSuccess"
                :on-format-error="handleFormatError"
				:beforeUpload="beforeFileUpload"
				>
                <Button icon="ios-cloud-upload-outline">选择文件</Button>
            </Upload>
            <div v-if="value !== '' && !showImage"
                style="margin-left:10px;">
                <Button icon="ios-search"
                    @click="showImageModal()">查看</Button>
            </div>
            <div v-if="value !== '' && showFileInNewTab"
                style="margin-left:10px;">
                <Button icon="ios-search"
                    @click="openFileInNewTab()">播放</Button>
            </div>
        </div>
    </div>
</template>
<script>
import { UPLOAD_FILE_API, FILE_SERVER } from '@/api/modules/files';

import * as imageConversion from 'image-conversion';

import { qiniuToken } from '@/api/modules/product-management/product-management';

export default {
    name: 'SingleFileUploadWithName',
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        imgWidth: {
            type: Number,
            default: 200
        },
        imgHeight: {
            type: Number,
            default: 200
        },
        format: {
            type: Array,
            default: () => {
                return ['jpg', 'jpeg', 'png', 'mp4'];
            }
        },
        showImage: {
            type: Boolean,
            default: true
        },
        showFileInNewTab: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value: {
            immediate: true,
            handler: function (newValue, oldValue) {
                if (newValue) {
                    this.imgPath = this.imageDomain + JSON.parse(newValue).url;
                }
            }
        }
    },
    data() {
        return {
            imgPath: FILE_SERVER + this.value,
            action:"https://up-z2.qiniup.com/", // UPLOAD_FILE_API, //"https://up-z2.qiniup.com/"
            file: null,
            uploadParams: {},
            imageDomain: this.imageDomain,
            showUploadList: false
        };
    },
    methods: {
        isMp4(){
            if(this.value && this.value.indexOf('.mp4') > -1){
                return true;
            }
            return false;
        },
        openFileInNewTab() {
            window.open(this.imgPath);
        },
        showImageModal() {
            this.$Modal.info({
                title: '图片信息',
                render: h => {
                    if(this.imgPath.indexOf("mp4") > -1){
                        return h("video", {
                            attrs: {
                                src: this.imgPath,
                                style: "width: 370px;height: 370px;"
                            }
                        });
                    }
                    else{
                        return h("img", {
                            attrs: {
                                src: this.imgPath,
                                style: "width: 370px;height: 370px;"
                            }
                        });
                    }
                }
            });
        },
        handleSuccess(res, file) {
            this.file = file;

            const data = { name: file.name, url: res.data.fileList[0].fileUuid };
            this.$emit('change', JSON.stringify(data));
            // this.$emit('input', JSON.stringify(data));
            this.$nextTick(() => {
                this.imgPath = FILE_SERVER + 'upload/' + res.data.fileList[0].fileUuid;
            });

        },
        handleFormatError(file) {
            const str = this.format.join(', ');
            this.$Notice.warning({
                title: '文件格式错误',
                desc: '请选择 ' + str + ' 后缀的文件.'
            });
        },
        beforeUpload(file) {
            console.log(file);
		    return new Promise((resolve, reject) => {
		       // console.log('压缩前', file) // 压缩到500KB,这里的400就是要压缩的大小,可自定义
		        imageConversion.compressAccurately(file, 500).then(res => { // console.log(res)
		            res = new File([res], file.name, { type: res.type, lastModified: Date.now() });
		          //  console.log('压缩后', res);
		            resolve(res);
		        });
		    });
        },
        async beforeFileUpload(file) {
            // **注意这里的参数必须通过属性赋值，如果直接修改整个uploadParams是无效的。**
            // 上传之前设置上传参数,
            let suffix = file.name.substring(file.name.lastIndexOf("."));
            let filename = Date.now() + Math.random().toString(36).slice(2) + suffix;
            await qiniuToken({}).then(res => {
                this.uploadParams.token = res.data.token;
                // 七牛response hash key的值自定义，后面如果需要浏览或者下载都需要这个地址，如果key不定义，那么七牛生成的key === hash的值
                this.uploadParams.key = filename;
            });
        },
        handleUploadFileSuccess(request, file, list) {
            let imagePath = this.imageDomain + file.response.key;
            this.file = file;
            const data = { name: file.name, url: file.response.key };
            this.$emit('change', JSON.stringify(data));
            // this.$emit('input', JSON.stringify(data));
            this.$nextTick(() => {
                this.imgPath = imagePath;
            });
        }
    }
};
</script>
